export const SEARCH_REQUEST="SEARCH_REQUEST"
export const SEARCH_SUCCESS="SEARCH_SUCCESS"
export const SEARCH_FAIL="SEARCH_FAIL"
export const SEARCH_DELETE="SEARCH_DELETE"